module.exports = __webpack_public_path__ + "img/introduce1.681b6ef6.jpg";